export const locale = {
    lang: 'pt',
    data: {
        ORDER_DETAIL_MODAL_RATING: {
            TITLE: 'Avalição do pedido',
            RATING_AVERAGE: 'Média da avaliação',
            DESCRIPTION: 'Descrição',
        },
    },
};
